import styled, { css } from 'styled-components'

export const HeaderWrapper = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	z-index: 9999;
	background: #fff;
	border-bottom: 1px solid #e8e8e8;
`

export const HeaderContainer = styled.header`
	max-width: 1440px;
	width: 100%;
	margin: 0 22px;
	display: flex;
	align-items: center;
	padding: 0 40px;
	height: 90px;
	justify-content: space-between;

	@media (max-width: 1024px) {
		padding: 0 20px;
		height: 70px;
	}
`

export const Logo = styled.a`
	display: block;
	padding: 0;

	img {
		height: 45px;
		width: auto;
		display: block;
		margin: 22px 0;

		@media (max-width: 1024px) {
			height: 30px;
			margin: 20px 0;
		}
	}
`

export const NavMenu = styled.ul`
	display: flex;
	list-style: none;
	margin: 0;
	padding: 0;
	margin-left: auto;
	height: 100%;
	gap: 40px;

	@media (max-width: 1024px) {
		display: none;

		&.open {
			display: block;
			position: fixed;
			top: 70px;
			left: 0;
			right: 0;
			bottom: 0;
			background: #fff;
			margin: 0;
			padding: 0;
			overflow-y: auto;
			z-index: 9999;
		}
	}
`

export const NavItem = styled.li`
	position: relative;
	height: 100%;
	display: flex;
	align-items: center;

	@media (max-width: 1024px) {
		height: auto;
		display: block;
		border-bottom: 1px solid #e8e8e8;

		&:last-child {
			border-bottom: none;
		}
	}
`

export const NavItemContent = styled.div`
	height: 100%;
	display: flex;
	align-items: center;
	cursor: pointer;
	position: relative;

	@media (max-width: 1024px) {
		height: auto;
	}
`

export const NavLink = styled.a`
	color: #54565a;
	text-decoration: none;
	font-size: 15px;
	font-weight: 600;
	padding: 35px 0;
	font-family: 'Helvetica Neue', Arial, sans-serif;
	white-space: nowrap;
	transition: color 0.15s ease;

	&:hover {
		color: #00a499;
	}

	@media (max-width: 1024px) {
		display: block;
		padding: 18px 20px;
		width: 100%;
		font-size: 16px;
	}
`

export const DropdownIcon = styled.span`
	display: none;

	@media (max-width: 1024px) {
		display: block;
		position: absolute;
		right: 20px;
		top: 50%;
		width: 8px;
		height: 8px;
		border-right: 2px solid #54565a;
		border-bottom: 2px solid #54565a;
		transform: ${(props) => (props.isOpen ? 'translateY(-70%) rotate(225deg)' : 'translateY(-30%) rotate(45deg)')};
		transition: transform 0.3s ease;
	}
`

export const SubMenu = styled.ul`
	display: none;
	position: absolute;
	top: 100%;
	left: 0;
	min-width: 240px;
	padding: 0;
	margin: 0;
	list-style: none;
	background: #fff;
	border: 1px solid #e8e8e8;
	border-radius: 10px;
	box-shadow: 2px 2px 4px 1px rgba(0, 0, 0, 0.3);
	z-index: 1000;

	${NavItem}:hover & {
		display: block;
	}

	@media (max-width: 1024px) {
		position: static;
		display: ${(props) => (props.isVisible ? 'block' : 'none')};
		min-width: 100%;
		box-shadow: none;
		border: none;
		border-radius: 0;
		background: #f7f7f7;
	}
`

export const SubMenuItem = styled.li`
	margin: 0;
	padding: 0;
	border-bottom: 1px solid #e8e8e8;

	&:first-child {
		a {
			border-radius: 10px 10px 0 0;
		}
	}

	&:last-child {
		border-bottom: none;
		a {
			border-radius: 0 0 10px 10px;
		}
	}

	a {
		display: block;
		padding: 12px 20px;
		color: #54565a;
		font-size: 15px;
		font-weight: 400;
		line-height: 1.5;
		text-decoration: none;
		transition: color 0.15s ease;

		&:hover {
			color: #ffffff;
			background-color: #37a89b;
		}
	}

	@media (max-width: 1024px) {
		a {
			padding: 15px 35px;
			background: #f7f7f7;

			&:hover {
				background: #f7f7f7;
			}
		}
	}
`

export const ButtonsWrapper = styled.div`
	display: flex;
	gap: 12px;
	margin-left: 40px;

	@media (max-width: 1024px) {
		display: none;
	}
`

export const RequestButton = styled.a`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	padding: 13px 26px;
	background: #00a499;
	color: #fff;
	font-size: 15px;
	font-weight: 600;
	text-decoration: none;
	border-radius: 6px;
	transition: all 0.15s ease;
	white-space: nowrap;
	font-family: 'Helvetica Neue', Arial, sans-serif;

	&:hover {
		background: #008e84;
		color: #fff;
		text-decoration: none;
	}
`

export const ContactButton = styled(RequestButton)`
	background: #0072ce;
	padding: 13px 24px;

	&:hover {
		background: #005ba3;
	}
`

export const MobileMenuButton = styled.button`
	display: none;
	padding: 0;
	width: 28px;
	height: 28px;
	background: none;
	border: none;
	cursor: pointer;
	margin-left: 18px;
	position: relative;

	span {
		display: block;
		width: 22px;
		height: 2px;
		background: #54565a;
		margin: 4px auto;
		transition: all 0.3s ease;

		${(props) =>
			props.isOpen &&
			css`
				&:nth-child(1) {
					transform: rotate(45deg) translate(5px, 5px);
				}

				&:nth-child(2) {
					opacity: 0;
				}

				&:nth-child(3) {
					transform: rotate(-45deg) translate(6px, -6px);
				}
			`}
	}

	@media (max-width: 1024px) {
		display: block;
	}
`
